import React from 'react';
import { BooleanCheck, isBooleanCheckFailed } from './BooleanCheck/BooleanCheck.esm.js';

const jsonRulesEngineCheckResultRenderer = {
  type: "json-rules-engine",
  component: (checkResult) => /* @__PURE__ */ React.createElement(BooleanCheck, { checkResult }),
  isFailed: isBooleanCheckFailed
};

export { jsonRulesEngineCheckResultRenderer };
//# sourceMappingURL=CheckResultRenderer.esm.js.map
